import * as React from "react";
import { StaticImage } from "gatsby-plugin-image";
import {
  Box,
  Container,
  SimpleGrid,
  Stack,
  Heading,
  Text,
  Flex,
  useColorModeValue,
  Link,
} from '@chakra-ui/react';
import { FaFacebook } from 'react-icons/fa';
import '../styles/footer.scss';
import {
  Link as GatsbyLink,
} from 'gatsby';

const ListHeader = ({ children }) => {
  return (
    <Text fontFamily={'PoppinsBold, sans-serif'} fontSize={'lg'} mb={2} textTransform={'uppercase'}>
      {children}
    </Text>
  );
};

export default function LargeWithLogoCentered() {
  return (
    <Box>
      <Box className="pre_footer">
        <Stack align={'center'} textAlign={'center'}>
          <Heading as='h3' fontSize={{ base: "22px", md: "24px"}}>Jameson Moving & Storage Also Serves Popular Local Areas:</Heading>
          <Link className="pre_footer_link" as={GatsbyLink} to={'/bellmawr-new-jersey'}>Bellmawr New Jersey Movers</Link>
          <Link className="pre_footer_link" as={GatsbyLink} to={'/deptford-township-new-jersey'} style={{margin: 0}}>Deptford Township New Jersey Movers</Link>
          <Link className="pre_footer_link" as={GatsbyLink} to={'/haddon-township-new-jersey'} style={{margin: 0}}>Haddon Township New Jersey Movers</Link>
          <Link className="pre_footer_link" as={GatsbyLink} to={'/marlton-new-jersey'} style={{margin: 0}}>Marlton New Jersey Movers</Link>
          <Link className="pre_footer_link" as={GatsbyLink} to={'/sewell-new-jersey'} style={{margin: 0}}>Sewell New Jersey Movers</Link>
          <Text style={{color: '#7B4B94', fontFamily: 'PoppinsMedium'}}>and Many More!</Text>
        </Stack>
      </Box>
      <Box className="footer">
        <Container className="links" as={Stack} maxW={'6xl'} py={10}>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
            <Stack align={'center'}>
              <ListHeader>Company</ListHeader>
              <Link as={GatsbyLink} to={'/about'}>About Us</Link>
              <Link as={GatsbyLink} to={'/moving-tips'}>Moving Tips</Link>
              <Link as={GatsbyLink} to={'/contact'}>Contact Us</Link>
            </Stack>
            <Stack align={'center'}>
              <ListHeader>Legal</ListHeader>
              <a className='footer_link' href={'https://www.fmcsa.dot.gov/sites/fmcsa.dot.gov/files/ReadytoMoveBrochure_2022Update.pdf'} target='_blank' rel="noopener nofollow noreferrer">Moving Checklist</a>
              <a className='footer_link' href={'https://www.fmcsa.dot.gov/sites/fmcsa.dot.gov/files/RightsandResponsibilitiesBooklet_2022Update.pdf'} target='_blank' rel="noopener nofollow noreferrer">Consumer Rights</a>
              <a className='footer_link' href={'https://www.freeprivacypolicy.com/live/072e2a67-00cc-49c1-a3c8-824980f2981a'} target='_blank' rel="noopener nofollow noreferrer">Privacy Policy</a>
            </Stack>
            <Stack align={'center'}>
              <ListHeader>Follow Us</ListHeader>
              <a className="socialMediaLink footer_link" target="_blank" rel="noopener nofollow noreferrer" href={'https://www.facebook.com/Jameson-Moving-and-Storage-109999558415876/'}>
                <FaFacebook />
                <Text pl="6px">Facebook</Text>
              </a>
            </Stack>
          </SimpleGrid>
        </Container>
        <Box pb={10}>
          <Flex
            align={'center'}
            _before={{
              content: '""',
              borderBottom: '1px solid',
              borderColor: useColorModeValue('gray.200', 'gray.700'),
              flexGrow: 1,
              mr: 8,
            }}
            _after={{
              content: '""',
              borderBottom: '1px solid',
              borderColor: useColorModeValue('gray.200', 'gray.700'),
              flexGrow: 1,
              ml: 8,
            }}>
            <Link as={GatsbyLink} to='/'>
              <StaticImage
                height={50}
                src='../images/JamesonMovingLogoWhite.png'
                alt='Jameson Moving & Storage Logo'
                placeholder='none'
              ></StaticImage>
            </Link>
          </Flex>
          <SimpleGrid columns={1} spacing={0} margin={"0 auto"}>
            <Stack align={'center'}>
            <Text pt={6} fontSize={'md'} textAlign={'center'} fontFamily='Poppins, sans-serif'>1 Eves Dr. Suite 111 Marlton NJ 08053</Text>
              <Text pt={2} fontSize={'md'} textAlign={'center'} fontFamily='PoppinsBold, sans-serif'>
                LICENSES
              </Text>
            </Stack>
            <Stack align={'center'}>
              <Text pt={1} fontSize={'sm'} textAlign={'center'}>
                US DOT# 3030099
              </Text>
            </Stack>
            <Stack align={'center'}>
              <Text fontSize={'sm'} textAlign={'center'}>
                MC #1622278
              </Text>
            </Stack>
            <Stack align={'center'}>
              <Text fontSize={'sm'} textAlign={'center'}>
                NJ #39PM00133200
              </Text>
            </Stack>
          </SimpleGrid>
          <Text pt={6} fontSize={'sm'} textAlign={'center'}>
            © 2023 Jameson Moving & Storage, LLC. All rights reserved.
          </Text>
        </Box>
      </Box>
    </Box>
  );
}